<style>
  .footer-links a {
    display: flex;
    align-items: center;
    gap: 10px;
    text-decoration: none;
  }

  .footer-links a:hover {
    color: #ffdd55;
  }

  .footer-links i {
    font-size: 1.1rem;
    color: #ffc107;
  }
</style>
<footer class="main-footer">
  <div class="footer-top">
    <div class="container">
      <div class="footer-grid">

        <!-- Brand / About -->
        <div class="footer-brand">
          <div class="brand d-flex align-items-center mb-3 cursor-pointer" [routerLink]="dashboardRoute">

            <div class="emblem" [routerLink]="['/home']" style="cursor: pointer;"> <img
                src="../../../assets/images/logos/hplogo.png" alt="HP Logo" width="50" />
            </div>

            <div class="brand-text ps-2">
              <span class="brand-name">Department of Cooperation</span>
              <span class="brand-sub">Government of Himachal Pradesh</span>
            </div>
          </div>

          <p>
            Directorate of Cooperation,<br>
            Sahkaar Bhawan, Block No. 25,<br>
            SDA Complex, Kasumpti, Shimla – 171009
          </p>

          <h6 class="mt-2">
            Total Visits :
            <span class="badge bg-info">{{ visitCount }}</span>
          </h6>
        </div>

        <!-- Important Links -->
        <div class="footer-links">
          <h4>Important Links</h4>
          <ul>
            <li><a [routerLink]="['/actrules']"><i class="bi bi-briefcase"></i> Acts & Rules</a></li>
            <li><a [routerLink]="['/aboutus']"><i class="bi bi-info"></i> About Us</a></li>
            <li><a [routerLink]="['/contact']"><i class="bi bi-telephone"></i> Contact Us</a></li>
            <li><a [routerLink]="['/FeedBack']"><i class="bi bi-chat-dots"></i> Feedback</a></li>
            <li><a [routerLink]="['/faq']"><i class="bi bi-question-circle"></i> FAQ</a></li>
            <li><a routerLink="/calendar"><i class="bi bi-calendar"></i> Holiday Calendar</a></li>
            <li><a [routerLink]="['/psgact']"><i class="bi bi-file-earmark"></i> PSG Act</a></li>
          </ul>
        </div>


        <!-- Related Links -->
        <div class="footer-links">
          <h4>Related Links</h4>
          <ul>
            <li><a href="http://hpscb.com" target="_blank">HP State Co-operative Bank</a></li>
            <li><a href="http://hppanchayat.nic.in" target="_blank">Panchayati Raj</a></li>
            <li><a href="http://hprural.nic.in" target="_blank">Rural Development</a></li>
            <li><a href="http://admis.hp.nic.in/ehimapurti/welcome.asp" target="_blank">Food & Civil Supplies</a></li>
            <li><a href="http://www.himbunkar.co.in/" target="_blank">Himbunkar</a></li>
            <li>
              <a href="http://himachal.nic.in/index.php?lang=1&dpt_id=189" target="_blank">
                HP Woolfed
              </a>
            </li>
          </ul>
        </div>

        <!-- Support / Contact -->
        <div class="footer-contact">
          <h4>Support</h4>
          <ul>
            <li>
              <i class="bi bi-telephone"></i>
              0177-2620970
            </li>
            <li>
              <i class="bi bi-envelope-at"></i>
              rcs-hp@nic.in
            </li>
            <li>
              <i class="bi bi-globe"></i>
              <a href="http://coophp.nic.in" target="_blank">coophp.nic.in</a>
            </li>
          </ul>

          <!-- Additional Logos -->
          <div class="d-flex gap-2 mt-3">
            <img src="../../../assets/images/logos/LogoHPCD.png" alt="HPCD Logo" width="45" />
            <img src="../../../assets/images/logos/statehood50logo.png" alt="Statehood 50 Logo" width="45" />
          </div>
        </div>

      </div>
    </div>
  </div>

  <!-- Footer Bottom -->
  <div class="footer-bottom">
    <div class="container">
      <div class="footer-bottom-content text-center">
        <p>
          © {{ currentYear }} Government of Himachal Pradesh –
          Department of Cooperation. All Rights Reserved.
        </p>
        <p class="developer">
          Designed & Developed by <strong><a href="https://www.atishay.com" target="_blank">Atishay Ltd.</a></strong>
        </p>
      </div>
    </div>
  </div>
</footer>